<template>
  <el-dialog
    title="维护分类"
    :visible.sync="showDialog"
    class="dialog816"
    @close="diaClose"
    width="600px"
    :close-on-click-modal="false"
  >
    <!-- <el-button
                type="primary"
                v-preventReClick
                v-if="btnAuthorize.addBtn.btnEnable&&sid>0"
                @click="createFirst(2)"
              >新增二级字典</el-button>
              <el-button
                type="primary"
                v-preventReClick
                v-if="btnAuthorize.changeBtn.btnEnable"
                icon="el-icon-edit"
                @click="createFirst(3)"
              >修改</el-button>
              <el-button
                type="primary"
                v-preventReClick
                v-if="btnAuthorize.delBtn.btnEnable"
                 icon="el-icon-delete"
                @click="removeGoodsCate()"
              >删除</el-button> -->
    <div style="margin-bottom: 10px">
      <el-button type="primary" @click="createFirst(2)">新增类型</el-button>
    </div>

    <div class="tableBox">
      <el-table
        background
        stripe
        ref="table2"
        :data="secondTableData"
        height="480px"
        size="mini"
        border
        highlight-current-row
        @row-click="secondCurrentChange"
      >
        <el-table-column prop="sort" label="排序"></el-table-column>
        <!-- <el-table-column
          prop="label"
          label="字典label"
          :show-overflow-tooltip="true"
        ></el-table-column> -->
        <el-table-column
          prop="value"
          label="类型名称"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="editType(scope.row)">修改</el-button>
            <el-button type="text" @click="removeGoodsCate(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog
      :title="dialogFormName"
      :visible.sync="isAddDialogShow"
      class="dialog816"
      @close="dialogClose"
      width="500px"
      append-to-body
    >
      <el-form
        size="mini"
        :model="dialogForm"
        :rules="formRules"
        ref="dialogForm"
        label-width="100px"
      >
        <el-row>
          <el-col :sapn="22">
            <el-form-item label="类型名称" prop="value">
              <el-input
                size="small"
                type="text"
                placeholder
                v-model="dialogForm.value"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :sapn="22">
            <el-form-item label="字典label" prop="label">
              <el-input
                size="small"
                placeholder
                v-model="dialogForm.label"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row>
          <el-col :sapn="22">
            <el-form-item label="排序：" prop="sort">
              <el-input
                size="small"
                placeholder
                v-model="dialogForm.sort"
                @input="verifyBillValue('sort')"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogClose()" type="info">取 消</el-button>
        <el-button
          type="primary"
          @click="onSubmit()"
          v-preventReClick
          style="margin-left: 10px"
          >保 存</el-button
        >
      </div>
    </el-dialog>
  </el-dialog>
</template>
<script>
import {
  BasicDataDetailService, //获取数据字典详细列表数据
  BasicDataTwoDetailsService, //获取二级数据字典内容
  insertBasicDataDetailService, //新增数据字典详情列表中的一项数据
  modifyBasicDataDetailService,
  BasicDataDetailsService, //获取单条数据字典信息
  deleteBasicDataDetailService,
} from "@/services/sysSettingService";
export default {
  name: "BasicDataDetailSetting",
  data() {
    return {
      dictId: 0, //字典id
      sid: 0, //是否二级数据字典 默认否
      colName: "字典名称", //一级字典列名
      // secondColName: "字典名称", //二级字典列名
      firstTableData: [], //一级类目table
      secondTableData: [], //二级类目table
      secondTableColum: {}, //二级table目录
      thirdTableData: [], //三级类目table
      selectFirstTable: [], //选中的一级类目
      selectSecondTable: [], //选中的二级类目
      selectThirdTable: [], //选中的三级类目   选中的类目使用多个分别保存是为了区分操作进行对应的刷新
      selectTable: [], //当前选中的数据
      showDialog:false,
      isAddDialogShow: false,
      selecttabData: {}, //选中得审批流类型
      dialogForm: {
        dictId: 0,
        label: "",
        sort: 0,
        pid: 0,
        value: "",
      },
      dialogFormName: "新建一级字典",
      dialogCode: 1,
      classification: 1, //新增分类级别
      formRules: {
        label: [{ required: true, message: "请输入字典标签", trigger: "blur" }],
        // sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
        sort: [
          { required: true, message: "请输入排序", trigger: "blur" },
          {
            pattern: /(^[0-9]\d*$)/,
            message: "输入内容必须为大于等于0的正整数",
            trigger: "blur",
          },
        ],
        value: [{ required: true, message: "请输入键值", trigger: "blur" }],
      },
      cateTypeCode: 1,
      btnAuthorize: {
        addOneBtn: { btnCode: "2020081116081989024", btnEnable: true },
        addBtn: { btnCode: "2020081116082852592", btnEnable: true },
        changeBtn: { btnCode: "2020081116083849231", btnEnable: true },
        delBtn: { btnCode: "2020081116084532071", btnEnable: true },
      },
    };
  },

  props: {
    menuCode: {
      type: String,
    },
  },
  methods: {
    showDialogFun(data) {
      this.showDialog = true;
      this.selecttabData = data;
      this.getFirstBasicData2(this.selecttabData);
    },
    //校验输入规则
    verifyBillValue(key, isIntNum = false) {
      let value = this.dialogForm[key];
      value = value.replace(/[^\d]/g, "");
      //value = value.replace(/^0[^\d]$/g, '');
      this.dialogForm[key] = value;
    },
    //查询二级字典目录
    getSecondBasicData() {
      let classification = 1;
      let params = {};
      params.dictId = this.selectTabData.id;
      BasicDataDetailsService(params)
        .then(
          (res) => {
            if (res.code == 10000000) {
              if (classification == 2) {
                this.secondTableColum = res.data;
              } else if (classification == 3) {
                this.secondTableColum = res.data;
              } else if (classification == 1) {
                // this.secondTableColum = res.data;
                this.secondColName = res.data.name;
              }
            } else {
              this.$alert(res.msg, "提示");
            }
          },
          (err) => {
            this.$message.error("系统异常");
          }
        )
        .catch((error) => {
          this.$message.error("网络请求失败");
        });
    },
    //查询一级字典
    getFirstBasicData() {
      let classification = 1;
      let params = {};
      params.dictId = this.dictId;
      BasicDataDetailService(params)
        .then(
          (res) => {
            if (res.code == 10000000) {
              if (classification == 2) {
                this.secondTableData = res.data;
                this.selectSecondTable = [];
                this.selectThirdTable = [];
              } else if (classification == 3) {
                this.thirdTableData = res.data;
                this.selectThirdTable = [];
              } else if (classification == 1) {
                this.firstTableData = res.data;
                this.selectFirstTable = [];
                this.selectSecondTable = [];
                this.selectThirdTable = []; //清空三个选中项
              }
            } else {
              this.$alert(res.msg, "提示");
            }
          },
          (err) => {
            this.$message.error("系统异常");
          }
        )
        .catch((error) => {
          this.$message.error("网络请求失败");
        });
    },

    //查询二级数据字典列表
    getFirstBasicData2(data) {
      let params = {};
      // params.dictId = this.dictId;
      params.pid = data.id;
      BasicDataTwoDetailsService(params)
        .then(
          (res) => {
            if (res.code == 10000000) {
              this.secondTableData = res.data;
              this.selectSecondTable = [];
              this.selectThirdTable = [];
            } else {
              this.$alert(res.msg, "提示");
            }
          },
          (err) => {
            this.$message.error("系统异常");
          }
        )
        .catch((error) => {
          this.$message.error("网络请求失败");
        });
    },
    //选中一级分类
    firstCurrentChange(data) {
      this.thirdTableData = [];
      if (this.sid > 0) {
        this.classification = 2;
        this.getFirstBasicData2(data.id, this.classification);
      }

      this.selectFirstTable = data;
      this.selectTable = data;
    },
    //选择二级分类
    secondCurrentChange(data) {
      // this.classification = 3;
      // this.getFirstBasicData(data.cateCode, this.classification);
      this.selectSecondTable = data;
      this.selectTable = data;
    },
    //选中三级分类
    thirdCurrentChange(data) {
      this.selectThirdTable = data;
      this.selectTable = data;
    },
    //新增分类
    createFirst(code) {
      //用code来判断执行的操作
      this.dialogCode = 2; //数据字典二级
      this.dialogFormName = "新建类型";
      this.isAddDialogShow = true;
      this.dialogForm.sort=this.secondTableData[this.secondTableData.length-1].sort+1
    },
    //修改
    editType(row) {
      //用code来判断执行的操作
      this.dialogCode = 3;

      this.dialogFormName = "修改";
      this.dialogForm.label = row.label;
      this.dialogForm.value = row.value;
      this.dialogForm.sort = row.sort;
      this.dialogForm.dictId = row.dictId;
      this.dialogForm.pid = row.pid;
      this.dialogForm.id = row.id;
      this.isAddDialogShow = true;
    },
    //关闭一层弹窗
    diaClose() {
      this.showDialog = false;
    },
    //关闭窗口
    dialogClose() {
      for (let key in this.dialogForm) {
        if (key != "user") {
          this.dialogForm[key] = "";
        }
      }
      this.$refs.dialogForm.resetFields();
      this.isAddDialogShow = false;
    },
    //新建一级分类
    onSubmit() {
      if (this.dialogCode == 1) {
        this.addDatasCate(1);
      } else if (this.dialogCode == 3) {
        this.modifyGoodsCate();
      } else if (this.dialogCode == 2) {
        this.addDatasCate(2);
      }
    },
    //新增
    addDatasCate(code) {
      console.log(this.selecttabData);
      this.$refs["dialogForm"].validate((valid) => {
        if (valid) {
          let params = {
            dictId: this.selecttabData?.sid ?? 0,
            // pid:this.dialogForm.pid,
            label:
              this.selecttabData.label +
              Math.floor(Math.random() * (150 - 0 + 1)) +
              0,
            sort: parseInt(this.dialogForm.sort),
            value: this.dialogForm.value,
          };
          if (code == 1) {
            params.pid = 0;
          } else if (code == 2) {
            params.dictId = this.selecttabData?.sid ?? 0;
            params.pid = this.selecttabData.id;
          } else {
            params.pid = this.selectTable.id;
          }
          // params.cateTypeCode = this.cateTypeCode;
          // if (this.selectTable.cateLevel == 1) {
          // } else if (this.selectTable.cateLevel == 2) {
          // }
          let paramstr = [];
          paramstr.push(params);
          insertBasicDataDetailService(paramstr).then((res) => {
            console.log(res);
            if (res.code == 10000000) {
              this.$alert("操作成功", "提示", {
                confirmButtonText: "确定",
              });
              this.$refs.dialogForm.resetFields();
              this.isAddDialogShow = false;
              if (code == 1) {
                this.secondTableData = [];
                this.thirdTableData = [];
                this.getFirstBasicData();
                this.selectTable = [];
              } else {
                this.showDialogFun(this.selecttabData);
              }
            } else {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    //修改
    modifyGoodsCate() {
      this.$refs["dialogForm"].validate((valid) => {
        if (valid) {
          let params = {
            id: this.dialogForm.id,
            pid: this.dialogForm.pid,
            dictId: this.dialogForm.dictId,
            label: this.dialogForm.label,
            sort: this.dialogForm.sort,
            value: this.dialogForm.value,
          };
          modifyBasicDataDetailService(params).then((res) => {
            console.log(res);
            if (res.code == 10000000) {
              this.$alert("操作成功", "提示", {
                confirmButtonText: "确定",
              });
              this.$refs.dialogForm.resetFields();
              this.isAddDialogShow = false;
              this.showDialogFun(this.selecttabData);
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
    //删除分类
    removeGoodsCate(row) {
      if(this.secondTableData.length<=1)
      {
        this.$message.warning("不能删除所有分类");
        return
      }
      this.$confirm("确认进行删除操作？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          dictIdSet: row.id,
        };
        deleteBasicDataDetailService(params).then((res) => {
          console.log(res);
          if (res.code == 10000000) {
            this.$alert("操作成功", "提示", {
              confirmButtonText: "确定",
            });

            this.thirdTableData = [];
            this.showDialogFun(this.selecttabData);
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
          (err) => {
            this.$message.error("系统异常");
          };
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/commonLayout.scss";
.BasicDataDetailSetting {
  width: 100%;
  height: 100%;
  display: flex;
  background-color: #fff;
  flex-direction: column;
}
/deep/.el-form-item__label {
  text-align: right;
}
.el-footer {
  text-align: right;
}
/deep/.el-col {
  text-align: left;
  padding-top: 20px;
}
/deep/.el-dialog {
  .el-select {
    width: 100%;
  }
}
/deep/.el-radio-button__inner {
  background: #d5e7ed;
  border: none;
  border-radius: 0;
  box-shadow: none;
  :hover {
    background: #069dbc;
    color: #fff;
  }
}
/deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: #fff;
  color: #069dbc;
  border: none;
  border-radius: 0;
  box-shadow: none;
  :hover {
    background: #069dbc;
    color: #fff;
  }
}
</style>